<div class="acc-application-status-log-dialog-part">
	<readonly-access [readonly]="accAppDialogDataService.isReadonly()"></readonly-access>
	<div class="row">
		<div class="col-lg-6">
			<acc-application-edit-status-log-part></acc-application-edit-status-log-part>
		</div>
		<div class="col-lg-6">
			<acc-application-status-log-list-part></acc-application-status-log-list-part>
		</div>
	</div>
</div>